import { render } from "./Campanhas.vue?vue&type=template&id=5e1b8b34&scoped=true"
import script from "./Campanhas.vue?vue&type=script&lang=js"
export * from "./Campanhas.vue?vue&type=script&lang=js"

import "./Campanhas.vue?vue&type=style&index=0&id=5e1b8b34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1b8b34"]])

export default __exports__